/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { cssProps } from '@oracle/oraclejet-cssprops';
import { ComponentChildren } from 'preact';
import { classNames } from '../utils/UNSAFE_classNames';
import { MessageVariant } from './Message.types';

const messageHeaderStyles = {
  base: cssProps`${{
    boxSizing: 'border-box',

    // TODO: Replace with Flex and ResponsiveProps when creating oj-c-message-banner
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    '@media screen and (max-width: 599.9px)': {
      flexDirection: 'column'
    }
  }}`,
  banner: cssProps`${{
    lineHeight: 'var(--oj-c-PRIVATE-DO-NOT-USE-message-banner-summary-line-height)'
  }}`,
  inline: undefined,
  toast: cssProps`${{
    lineHeight: 'var(--oj-c-PRIVATE-DO-NOT-USE-message-toast-start-icon-size)'
  }}`
};

/**
 * Props for the MessageHeader component
 */
type MessageHeaderProps = {
  variant?: MessageVariant;
  children?: ComponentChildren;
};
/**
 * A component that styles the header for the message component
 * @param param0 Props
 * @returns MessageHeader component instance
 */
export function MessageHeader({ children, variant = 'banner' }: MessageHeaderProps) {
  const rootClasses = classNames([messageHeaderStyles.base, messageHeaderStyles[variant]]);
  return (
    <div role="presentation" class={rootClasses}>
      {children}
    </div>
  );
}
